import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { MINICUOTAS_NAME } from '../../utils/constants'; 

function useVersion() {

  const { version, selectedBank } = useSelector(state => ({
    version: state.personalization?.data || {},
    selectedBank: state?.personalization?.additional?.bancos?.find(
      bank => bank.isSelected
    ) || {},
  }));

  const validateHasPromo = useCallback(() => {
    return version?.tienePromoCapital === '1';
  }, [version]);

  const [hasPromo, setHasPromo] = useState(validateHasPromo());

  const isPromoActive = useCallback(() => {
    if (!hasPromo) {
      return false;
    }
    return selectedBank?.post_type === MINICUOTAS_NAME;
  }, [hasPromo, selectedBank]);

  const [hasActivePromo, setHasActivePromo] = useState(isPromoActive());

  const getCurrentVersion = useCallback(() => {
    return version?.data;
  }, [version.data]);

  useEffect(() => {
    setHasPromo(validateHasPromo());
    setHasActivePromo(isPromoActive());
  }, [version, validateHasPromo, getCurrentVersion, isPromoActive]);
  

  return { hasActivePromo, hasPromo, version };
}

export default useVersion;

